import { render, staticRenderFns } from "./RolloverDetails.vue?vue&type=template&id=804993ee"
import script from "./RolloverDetails.vue?vue&type=script&lang=ts"
export * from "./RolloverDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports